import { useContext, useMemo } from "react"; // Fixed import
import '../css/admin/dashbord.css';
import { Button, Row, Col, Card } from "react-bootstrap";
import { 
  Activity, 
  CheckCircle2, 
  AlertCircle, 
  FileStack, 
  Building2, 
  MapPin, 
  ArrowRight 
} from "lucide-react";
import { Datacontext } from "../../context/dataContext";

export const Dashbord = ({ handleActive }) => {
    const { village, offices, docs, documents, loading } = useContext(Datacontext);

    // 1. Calculate the counts directly using useMemo
    const counts = useMemo(() => {
        if (loading || !documents) {
            return { proc: 0, comp: 0, rej: 0, off: 0, vill: 0, doc: 0 };
        }

        return {
            proc: documents.filter(d => d.docstatus === 'processing').length,
            comp: documents.filter(d => d.docstatus === 'completed').length,
            rej: documents.filter(d => d.docstatus === 'rejected').length,
            off: offices?.length || 0,
            vill: village?.length || 0,
            doc: docs?.length || 0
        };
    }, [loading, documents, offices, village, docs]);

    const StatusCard = ({ title, value, icon: Icon, colorClass }) => (
        <Card className="stats-card-modern">
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                    <div>
                        <p className="stats-label-modern">{title}</p>
                        <h2 className="stats-value-modern">{value}</h2>
                    </div>
                    <div className={`icon-wrapper-modern ${colorClass}`}>
                        <Icon size={24} />
                    </div>
                </div>
                <div className="stats-footer-modern">
                    <span className="text-success small fw-bold">Active Records</span>
                </div>
            </Card.Body>
        </Card>
    );

    const ResourceCard = ({ title, value, icon: Icon, action, colorClass }) => (
        <Card className="resource-card-modern">
            <Card.Body className="p-4">
                <div className={`resource-icon-circle ${colorClass}`}>
                    <Icon size={22} />
                </div>
                <h4 className="resource-title">{title}</h4>
                <div className="d-flex align-items-baseline gap-2 mb-3">
                    <h3 className="resource-value">{value}</h3>
                    <span className="text-muted small">Total Entities</span>
                </div>
                <Button 
                    variant="link" 
                    className="p-0 resource-action-btn text-decoration-none" 
                    onClick={action}
                >
                    Manage Resources <ArrowRight size={16} className="ms-1" />
                </Button>
            </Card.Body>
        </Card>
    );

    return (
        <div className="dashboard-container-modern">
            <div className="dashboard-header-modern">
                <div className="header-content">
                    <h3>Administrative Overview</h3>
                    <p>System-wide metrics and resource management</p>
                </div>
            </div>

            <Row className="g-4 mb-5">
                <Col lg={4}>
                    {/* 2. Use 'counts' variable instead of 'count' state */}
                    <StatusCard title="In Progress" value={counts.proc} icon={Activity} colorClass="purple" />
                </Col>
                <Col lg={4}>
                    <StatusCard title="Successful" value={counts.comp} icon={CheckCircle2} colorClass="green" />
                </Col>
                <Col lg={4}>
                    <StatusCard title="Rejected" value={counts.rej} icon={AlertCircle} colorClass="red" />
                </Col>
            </Row>

            <div className="section-title-modern">
                <h5>Resource Management</h5>
                <hr />
            </div>

            <Row className="g-4">
                <Col lg={4}>
                    <ResourceCard title="Document Types" value={counts.doc} icon={FileStack} colorClass="blue" action={() => handleActive('doc')} />
                </Col>
                <Col lg={4}>
                    <ResourceCard title="Reg. Offices" value={counts.off} icon={Building2} colorClass="pink" action={() => handleActive('office')} />
                </Col>
                <Col lg={4}>
                    <ResourceCard title="Covered Villages" value={counts.vill} icon={MapPin} colorClass="teal" action={() => handleActive('village')} />
                </Col>
            </Row>
        </div>
    );
};